import { Text } from 'react-native-paper';
import { HeaderStyles } from './headerTypes';

export const SubHeaderText = ({ children }: { children: React.ReactNode }) => {
  return <Text style={HeaderStyles.headerText}>{children}</Text>;
};
